//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import TrackList from "@/components/Track/TrackList";
import { GetTokenInfo } from "@/services/auth.js";
export default {
  components: {
    TrackList
  },
  props: {
    id: {
      type: String,
      required: true
    },
    nowPlayingId: {
      type: String
    }
  },
  data() {
    return {
      popularTracks: [],
      accessToken: null,
      artist: null,
      genius: null
    };
  },
  methods: {
    getArtistInfo(artistId) {
      axios
        .get(`https://api.spotify.com/v1/artists/${artistId}`, {
          headers: {
            authorization: `Bearer ${this.accessToken}`
          }
        })
        .then(response => {
          this.artist = response.data;
        });
    },
    geniusSearch(q) {
      axios
        .get(
          `${
            process.env.VUE_APP_FIREBASE_FUNCTIONS_BASE
          }/searchGenius?q=${encodeURIComponent(q)}`
        )
        .then(response => {
          if (
            response.data.response.hits &&
            response.data.response.hits.length
          ) {
            var exactMatch = response.data.response.hits.find(x => {
              let sanitizedGeniusName = x.result.primary_artist.name
                .toLowerCase()
                .replace(/[^a-z0-9]/g, "");

              let sanitizedSpotifyName = q
                .toLowerCase()
                .replace(/[^a-z0-9]/g, "");

              let equal = sanitizedGeniusName === sanitizedSpotifyName;
              return equal;
            });
            if (exactMatch) {
              this.getGeniusInfo(exactMatch.result.primary_artist.id);
            } else {
              this.genius = null;
            }
          } else {
            this.genius = null;
          }
        });
    },
    getGeniusInfo(geniusArtistId) {
      axios
        .get(
          `${process.env.VUE_APP_FIREBASE_FUNCTIONS_BASE}/artist?id=${geniusArtistId}`
        )
        .then(response => {
          this.genius = response.data.response.artist;
        });
    },
    getPopularTracksForArtist(artistId) {
      axios
        .get(
          `https://api.spotify.com/v1/artists/${artistId}/top-tracks?country=from_token`,
          {
            headers: {
              authorization: `Bearer ${this.accessToken}`
            }
          }
        )
        .then(response => {
          this.popularTracks = response.data.tracks;
        });
    },
    refresh() {
      GetTokenInfo().then(token => {
        this.accessToken = token.accessToken;
        this.getPopularTracksForArtist(this.id);
        this.getArtistInfo(this.id);
      });
    }
  },
  watch: {
    id() {
      this.refresh();
    },
    artist() {
      this.genius = null;
      this.geniusSearch(this.artist.name);
    }
  },
  created() {
    this.refresh();
  }
};
